import util from "@/mixins/util";

const configBoardFilter = {
    notice: {
        getFunc: 'getNotice',
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            type: 'post',
            dot:'created_at',
            dos:'desc',
            // cid: 1,
            la: 1,
        },
    },
    noticeCreate: {
        getKeyName: 'id',
        writeFunc: 'createNotice',
        writeApiParamSet: {
            type: 'post',
            wr_type: 'post',
            language: 'create',
        },
        parsingData: {
            title: 'wr_subject',
            content: 'wr_content',
            headText: 'wr_headtext',
            language: 'c_idx',
        },
        fileType: '',
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {},
    },
    noticeUpdate: {
        getFunc: 'getNotice',
        detailApiParamsSet: {
            ip: 0,
            type: 'post',
            la: 1
        },
        getKeyName: 'id',
        writeFunc: 'updateNotice',
        writeApiParamSet: {
            language: 'update',
            type: 'post',
            wr_type: 'post'
        },
        parsingData: {
            title: 'wr_subject',
            content: 'wr_content',
            wr_seq: 'wr_seq',
        },
        fileType: '',
        directUrl: '',
        directType: 'back',
        keyName: 'wr_id',
        writeSuccessType: 1,
        writeFailTypes: {},
        deleteFunc: 'deleteNotice',
        deleteApiParamsSet: {
            type: 'post'
        },
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-522': '매칭된 배너가 존재하여 삭제할수 없습니다.'
        },
        deleteErrorTypes: {},
        detailKey: ''
    },
    faq: {
        getFunc: 'getFaq',
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            type: 'post',
            c: 1,
            la: 1,
            obt: 'wr_seq',    //정렬하고 싶은 컬럼값
            obs: 'asc',      //정렬하고싶은 방식 asc:오름차순,desc:내림차순
        },
        pageRow: 10,

    },
    faqCreate: {
        getFunc: '',
        detailApiParamsSet: {},
        getKeyName: 'id',
        writeFunc: 'createFaq',
        writeApiParamSet: {
            language: 'create',
            type: 'post',
            wr_type: 'post'
        },
        parsingData: {
            title: 'wr_subject',
            content: 'wr_content',
            bc_idx: 'bc_idx',
            language: 'c_idx',
            seq: 'wr_seq',
        },
        directUrl: '',
        directType: 'back',
        keyName: 'id',
        writeSuccessType: 1,
        writeFailTypes: {},
    },
    faqUpdate: {
        getFunc: 'getFaq',
        detailApiParamsSet: {
            ip: 0,
            type: 'post',
            la: 1
        },
        getKeyName: 'id',
        writeFunc: 'updateFaq',
        writeApiParamSet: {
            language: 'update',
            type: 'post',
        },
        parsingData: {
            title: 'wr_subject',
            content: 'wr_content',
            bc_idx: 'bc_idx',
            seq: 'wr_seq',
        },
        directUrl: '',
        directType: 'back',
        keyName: 'wr_id',
        writeSuccessType: 1,
        writeFailTypes: {},
        deleteFunc: 'deleteFaq',
        deleteApiParamsSet: {
            type:'post'
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    category: {
        getFunc: 'getCategory',
        detailApiParamsSet: {
            ip: 0,
        },
        writeSuccessType: 1,
        writeFailTypes: {},
        writeFunc: 'updateCategory',
        writeApiParamSet: {
            bc_idx: '',
            bc_name: '',
            bc_seq: '',
        },
        parsingData: {},
        keyName: 'bc_idx',

        deleteFunc: 'deleteCategory',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    qna: {
        getFunc: 'getQna',
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            type: 'post',
            cmt: 1,
            cmtd: 1,
            wr: 1,
        },
        pageRow: 10,
    },

    qnaUpdate: {
        getFunc: 'getQna',
        detailApiParamsSet: {
            ip: 0,
            type: 'post',
            cmt: 1,
            cmtd: 1,
            wr: 1,
            f: 1,
        },
        getKeyName: 'id',
        writeFunc: 'createQna',
        writeApiParamSet: {
            wr_type: 'comment',
            type: 'post'
        },
        parsingData: {
            title: 'wr_subject',
            content: 'wr_content',
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {},
        fileType: 'qna_admin',

        deleteFunc: 'deleteQna',
        deleteApiParamsSet: {
            type: 'post'
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteErrorTypes: {},
        keyName: 'wr_id'
    },
}

export default {
    methods: {
        returnBoardFilterConfig(type) {
            return configBoardFilter[type];
        },

    },
    data() {
        return {}
    },
    filterConfig: {
        su: {
            type: 'query',
            classname: 'searchInput'
        },
        co: {
            type: 'query',
            classname: 'searchInput'
        },
        cid: {
            type: 'match',
            classname: 'langOption'
        },
        ca: {
            type: 'match',
            classname: 'filterCategory'
        },
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        mid: {
            type: 'query',
            classname: 'searchInput'
        },
        mbid: { //1:1문의 작성자 아이디
            type: 'query',
            classname: 'searchInput'
        },
        ni: {
            type: 'query',
            classname: 'searchInput'
        },
        mbni: { // 1:1문의 작성자 닉네임
            type: 'query',
            classname: 'searchInput'
        },
        isa: {
            type: 'match',
            classname: 'qaStatus'
        },
        ti: {
            type: 'query',
            classname: 'searchInput'
        },
        ty: {
            type: 'match',
            classname: 'searchInputOption'
        },
    }
}
